import { render, staticRenderFns } from "./promotionList.vue?vue&type=template&id=76870459&scoped=true&"
import script from "./promotionList.vue?vue&type=script&lang=js&"
export * from "./promotionList.vue?vue&type=script&lang=js&"
import style0 from "./promotionList.vue?vue&type=style&index=0&id=76870459&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76870459",
  null
  
)

export default component.exports